import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HardHat } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const run = async () => {
      if (!sessionId) { navigate("/"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        applyAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        navigate("/");
      }
    };
    run();
  }, [navigate, applyAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0b0d10]">
      <HardHat className="h-10 w-10 text-primary animate-pulse" />
      <p className="mt-4 text-slate-400 text-sm">Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
